import { render, staticRenderFns } from "./ProductEqualRecord.vue?vue&type=template&id=2ef7394e&scoped=true"
import script from "./ProductEqualRecord.vue?vue&type=script&lang=js"
export * from "./ProductEqualRecord.vue?vue&type=script&lang=js"
import style0 from "./ProductEqualRecord.vue?vue&type=style&index=0&id=2ef7394e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef7394e",
  null
  
)

export default component.exports